import React from "react";
import { ArrowRightIcon, PhoneIcon } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { business } from "../data/business";
import { extraServices, services, serviceTypeById } from "../data/services";
import { ui } from "../data/ui";
import { requestService } from "../utils/serviceRequest";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
export function Services() {
  const {
    t
  } = useLanguage();
  return <section id="services" aria-labelledby="services-title" className="bg-ink py-20 lg:py-28" data-id="element-336" data-mp="z4mn50ktfcrw">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-337" data-mp="u5s4pzqrfq8b">
        <SectionHeading id="services-title" title={t(ui.services.title)} subtitle={t(ui.services.subtitle)} aside={<a href="#contact" className="btn-gold self-start lg:self-auto" data-id="element-339" data-mp="l5n01xcyb5xu">
              {t(ui.common.getEstimate)}
            </a>} data-id="element-338" data-mp="u6bbqlevgu7k" />

        <ul className="mt-12 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4" data-id="element-340" data-mp="g8da8glngs9h">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <li key={service.id} className="bg-ink" data-id="element-341" data-mp="2xbrsph26afrr" data-mpi={i}>
                <Reveal delay={i % 4 * 0.04} className="h-full" data-id="element-342" data-mp="2xdckx010lmmg">
                  <article className="group relative flex h-full flex-col bg-ink p-7 transition-[background-color,box-shadow] duration-200 ease-out hover:bg-charcoal hover:shadow-glow" data-id="element-343" data-mp="32a30znctki7v">
                    <Icon className="h-10 w-10 text-gold" strokeWidth={1.4} aria-hidden="true" data-id="element-344" data-mp="3u1sfjaizem6f" />
                    <h3 className="mt-6 text-base font-bold uppercase tracking-[0.1em] text-white" data-id="element-345" data-mp="3g2j5ksldcoaw">{t(service.name)}</h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-smoke" data-id="element-346" data-mp="3l0knvbaz0jlb">{t(service.description)}</p>
                    <a href="#contact" onClick={() => requestService(serviceTypeById[service.id], t(service.name))} className="mt-auto inline-flex items-center gap-1.5 pt-6 text-sm font-semibold text-gold after:absolute after:inset-0 focus-visible:outline-none" aria-label={`${t(ui.services.learnMore)}: ${t(service.name)}`} data-id="element-347" data-mp="24m2m8o6p1nir">
                      <span className="link-slide" data-id="element-348" data-mp="1gpo5g79npgtv">{t(ui.services.learnMore)}</span>
                      <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-349" data-mp="1bs65359pg9xh" />
                    </a>
                    <span className="absolute inset-x-0 bottom-0 h-0.5 origin-left scale-x-0 bg-gold transition-transform duration-200 ease-out-strong group-hover:scale-x-100 group-focus-within:scale-x-100" aria-hidden="true" data-id="element-350" data-mp="11tgnldlq0rhr" />
                  </article>
                </Reveal>
              </li>;
        })}
        </ul>

        <Reveal className="mt-10 flex flex-col gap-6 border-y border-gold/30 py-8 lg:flex-row lg:items-center lg:justify-between" data-id="element-351" data-mp="2n8w6mb36odkr">
          <div data-id="element-352" data-mp="2ur3ut70ym9ed">
            <p className="font-display text-xl font-semibold text-white sm:text-2xl" data-id="element-353" data-mp="2upj8g4ostwrl">{t(ui.services.customTitle)}</p>
            <p className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-smoke" data-id="element-354" data-mp="34hf9nom6m301">
              <span data-id="element-355" data-mp="39g0a9p5ciop0">{t(ui.services.alsoTitle)}:</span>
              {extraServices.map((s, i) => <span key={s.en} className="text-gold" data-id="element-356" data-mp="2bsrhd930mdcz" data-mpi={i}>
                  {t(s)}
                  {i < extraServices.length - 1 && <span className="ml-3 text-white/30" aria-hidden="true" data-id="element-357" data-mp="2gr2v3uwfl80h">·</span>}
                </span>)}
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row" data-id="element-358" data-mp="2lss5d8btxhni">
            <a href="#contact" onClick={() => requestService("custom")} className="btn-gold" data-id="element-359" data-mp="2ptc0y7gr8d7j">
              {t(ui.services.customCta)}
            </a>
            <a href={business.phoneHref} className="btn-outline" data-id="element-360" data-mp="12syl26itemh">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-361" data-mp="50gxegbc3rjn" />
              {business.phoneShort}
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}